<h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
            <esl-message-toast [(message)]="error"></esl-message-toast>
            <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
            </div>
         <!--Laboratory form  -->
            <div class="ui segment section">
                  <div class="sub-value">Certificate of Incorpration</div>
                  <div><span class="sub-label">mandatory</span></div>
            </div>

            <div class="ui segment section">
                  <div class="sub-value">Tax Clerance Certificate</div>
                  <div><span class="sub-label">mandatory</span></div>
            </div>

            <div class="ui segment section">
                  <div class="sub-value">Certificate of Technical Staff</div>
                  <div><span class="sub-label">mandatory</span></div>
            </div>

            <div class="ui segment dark">
                  <div >Certificate of Incorpration</div>
                  <div><span class="sub-label">mandatory</span></div>
            </div>

            <div class="ui segment section">
                  <div class="sub-value">Company Profile</div>
                 
            </div>

            
            <div class="ui segment section">
                  <div class="sub-value">Cerficate of Insurance</div>
                 
            </div>

            <div class="ui segment section">
                  <div class="sub-value">Co-operate Profile</div>
                 
            </div>
 </div>
 </div>

      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="nextDocument()" autofocus>Next</button>

      </div>


